import React, { useState, useMemo, useEffect } from 'react';

import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
} from 'reactstrap';

import Select from 'react-select';

import { selectStyle } from '../../../helper/form';

import { tooltipText } from '../../../helper/common';

import DistributionListFilterModalForm from './modal_form';

import { routes, indexService, destroyService } from './utils';

const DistributionListFilterContainer = props => {

  const {
    dataTable,
    filters,
    distributionList,
    showAllRecordsRef,
    selectedRecords,
    callbacks: {
      onApplyFilters,
      onSetDistributionList
    }
  } = props;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [distributionLists, setDistributionLists] = useState([])

  const urls = useMemo(() => {
    try {
      return routes[props?.configuration?.context](props) || {};
    } catch (error) {
      return {};
    }
  }, [props?.configuration?.context]);

  const {
    defaultRequestParams,
    indexRoute,
    destroyRoute
  } = urls;

  useEffect(() => {
    fetchDistributionLists();
  }, [])

  const fetchDistributionLists = () => {
    indexService(indexRoute(defaultRequestParams)).then(response => {
      setDistributionLists(response.data.distribution_list_filters);
    }).catch(error => {
      console.error(error);
    })
  }

  const onDestroyDistributionListConfirm = event => {
    event.preventDefault();
    swalWithBootstrap.fire({
      title: I18n.t('bulk.datatable.distribution_list_filters.destroy.title'),
      html: I18n.t('bulk.datatable.distribution_list_filters.destroy.text', { name: 'Mi lista' }),
      showCancelButton: true,
    }).then(result => {
      if (result.isConfirmed) {
        onDestroyDistributionList();
      }
    })
  }

  const onDestroyDistributionList = () => {
    let requestParams = {
      ...defaultRequestParams,
      id: distributionList?.id,
      type: 'destroy',
    }

    destroyService(destroyRoute(requestParams)).then(response => {
      if (response.status == 200) {
        onSetDistributionList(null);
        fetchDistributionLists();
      }

      swalToastBootstrap.fire({
        icon: 'success',
        title: I18n.t('bulk.datatable.distribution_list_filters.destroy.successfully')
      })
    }).catch(error => {
      console.error(error);
    })
  }
  // ========================================
  // ========== START BUTTONS ==========
  const destroyButton = () => {
    if (distributionList?.id) {
      return (
        <Button
          color="danger"
          size='sm'
          className='ml-1'
          onClick={onDestroyDistributionListConfirm}
        >
          <i className="fas fa-trash"></i>
        </Button>
      )
    }
  }

  const editButton = () => {
    if (distributionList?.id) {
      return (
        <Button
          color="primary"
          block={true}
          onClick={() => setModalIsOpen(true)}
        >
          {/* <i className="fas fa-edit"></i>
          &nbsp; */}
          {I18n.t('bulk.datatable.distribution_list_filters.edit.button')}
        </Button>
      )
    }
  }

  const newButton = () => {
    if (!distributionList?.id) {
      return (
        <Button
          color="success"
          block={true}
          onClick={() => setModalIsOpen(true)}
        >
          {/* <i className="fas fa-plus"></i>
          &nbsp; */}
          {I18n.t('bulk.datatable.distribution_list_filters.new.button')}
        </Button>
      )
    }

  }
  // ========== END BUTTONS ==========
  // ========================================
  // ========== START DISTRIBUTION LISTS ==========
  const distributionListsOptions = useMemo(() => {
    return _.map(distributionLists, distributionList => ({
      value: distributionList.id,
      label: distributionList.name
    }))
  }, [distributionLists])

  const distributionListSelectedOption = useMemo(() => {
    return _.find(distributionListsOptions, { value: distributionList?.id }) || null
  }, [distributionList, distributionListsOptions])

  const onChangeSelectedDistributionList = event => {
    let _distributionList = getDistributionListById(event?.value || '')

    if (_distributionList) {
      _distributionList.filters = { ..._distributionList.filters }
    }

    showAllRecordsRef.current = true

    onSetDistributionList(_distributionList);
  }

  const getDistributionListById = id => {
    return _.find(distributionLists, { id: id })
  }

  const messageSelectedDistributionList = () => {
    if (distributionList?.id) {
      return (
        <Row className='mt-2'>
          <Col md={12}>
            <small className='text-info'>
              Se ha aplicado la lista de distribución <strong>{distributionList?.name}</strong> y se han seleccionado <strong>{selectedRecords?.length}</strong> items
            </small>
          </Col>
        </Row>
      )
    }
  }
  // ========== END DISTRIBUTION LISTS ==========

  return (
    <Row>
      <Col>
        <Card className="bg-real-light">
          <CardBody>
            <Row>
              <Col md={8}>
                <Row>
                  <Col md={6} className={'d-grid align-items-center'}>
                    <Label className='mb-0'>
                      <i className="fas fa-clipboard-list mr-2"></i>
                      {I18n.t(`controldoc.datatable.distribution_list_filter.title`)}
                      {tooltipText(I18n.t(`controldoc.datatable.distribution_list_filter.tooltip_info`))}
                    </Label>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={8}>
                        <Select
                          isClearable={true}
                          placeholder={''}
                          options={distributionListsOptions}
                          value={distributionListSelectedOption}
                          styles={selectStyle}
                          onChange={onChangeSelectedDistributionList}
                        />
                      </Col>
                      <Col md={2} className={'d-grid align-items-center'}>
                        {destroyButton()}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col md={4}>
                {editButton()}
                {newButton()}
              </Col>

              {messageSelectedDistributionList()}
            </Row>
          </CardBody>
        </Card>
      </Col>

      <DistributionListFilterModalForm
        dataTable={dataTable}
        modalIsOpen={modalIsOpen}
        distributionList={distributionList}
        filters={filters || {}}
        configuration={{
          context: props?.configuration?.context,
        }}
        callbacks={{
          onSetModalIsOpen: setModalIsOpen,
          onApplyFilters: onApplyFilters,
          onFetchDistributionLists: fetchDistributionLists,
          onSetDistributionList: onSetDistributionList,
          onDestroyDistributionList: onDestroyDistributionList,
        }}
      />
    </Row>
  )
}

export default DistributionListFilterContainer;
